(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('CommissioneDetailController', CommissioneDetailController);

    CommissioneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Commissione'];

    function CommissioneDetailController($scope, $rootScope, $stateParams, previousState, entity, Commissione) {
        var vm = this;

        vm.commissione = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('gestioneAttiApp:commissioneUpdate', function(event, result) {
            vm.commissione = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
